<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Add Property"
    icon="add"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlComboBox
              label="Name*"
              :items="propertyKeyList"
              item-text="key"
              autofocus
              v-model="key"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlTextField
              label="Value*"
              autofocus
              v-model="value"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlComboBox from '../../../common/components/controls/ControlComboBox'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlComboBox,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    assetDetail: {
      type: Object,
      required: true,
    },
    propertyKeyList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    key: null,
    value: null,
  }),
  computed: {},
  watch: {
    showDialog() {
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        assetId: this.assetDetail.id,
        key: this.key && this.key.key ? this.key.key : this.key,
        value: this.value,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.key = null
      this.value = null
    },
  },
}
</script>